/*
 * Copyright 2019 NEM
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Catapult REST API Reference
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 0.7.15
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */


import ApiClient from '../ApiClient';


/**
* Enum class MosaicPropertyIdEnum.
* @enum {}
* @readonly
*/
export default class MosaicPropertyIdEnum {
    
        /**
         * value: 0
         * @const
         */
        0 = 0;

    
        /**
         * value: 1
         * @const
         */
        1 = 1;

    
        /**
         * value: 2
         * @const
         */
        2 = 2;

    

    /**
    * Returns a <code>MosaicPropertyIdEnum</code> enum value from a Javascript object name.
    * @param {Object} data The plain JavaScript object containing the name of the enum value.
    * @return {module:model/MosaicPropertyIdEnum} The enum <code>MosaicPropertyIdEnum</code> value.
    */
    static constructFromObject(object) {
        return object;
    }
}


